import { render, staticRenderFns } from "./EditSipUserDialog.vue?vue&type=template&id=a4dba106"
import script from "./EditSipUserDialog.vue?vue&type=script&lang=js"
export * from "./EditSipUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4dba106')) {
      api.createRecord('a4dba106', component.options)
    } else {
      api.reload('a4dba106', component.options)
    }
    module.hot.accept("./EditSipUserDialog.vue?vue&type=template&id=a4dba106", function () {
      api.rerender('a4dba106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/sips/EditSipUserDialog.vue"
export default component.exports